import axios from 'axios'
import { BASE_URL } from './base-url'

var baseurl = BASE_URL;

export default class AnalyticsService {
  /**
   * Get all videos for the client. with pagination
   * 
   * @param {string} token 
   * @param {[Video]} videos
   * @return {[Video]}
   */
  getPercentRebufVideo(token, video) {
    return new Promise((done, reject) => {
      var date = new Date()
      var date2 = new Date()
      date2.setHours(date.getHours() - 1)
      const params = {
        "query": {
          "bool": {
            "filter": {
              "range": {
                "timestamp": {
                  "from": date2.toISOString(),
                  "to": date.toISOString()
                }
              }
            }
          }
        },
        "aggs": {
          "sum_sec_server": {
            "sum": {
              "field": "sec_server"
            }
          },
          "sum_sec_peer": {
            "sum": {
              "field": "sec_peer"
            }
          },
          "sum_sec_rebuff": {
            "sum": {
              "field": "sec_rebuf"
            }
          }
        }
      };
      var instance = {
        baseURL: base + '/' + video.authorizationKey.toLowerCase() + '/_search?pretty',
        method: 'post',
        data: params,
      };
      axios(instance).then((response) => {
        done(response);

      }).catch((error) => {
        reject(error);
      })

    })
  }

  getGlobalAnalytics(date, index) {
    return new Promise((done, reject) => {

      const params = {
        "query": {
          "bool": {
            "filter": {
              "range": {
                "timestamp": {
                  "from": date.dateF.toISOString(),
                  "to": date.dateT.toISOString()
                }
              }
            }
          }
        },
        "aggs": {
          "tot_nbVues": {
            "sum": {
              "field": "nbVues"
            }
          },
          "tot_data_delivered": {
            "sum": {
              "field": "tot_amount_data"
            }
          },
          "tot_hours_view": {
            "sum": {
              "field": "tot_hours_view"
            }
          }
        }
      };
      var instance = {
        baseURL: base + `/global${index.toLowerCase()}/_search?pretty`,
        method: 'post',
        data: params,
      };
      axios(instance).then((response) => {
        done(response);

      }).catch((error) => {
        reject(error);
      })

    })
  }


  getSelectAnalytics(date, authorizationKeys) {
    return new Promise((done, reject) => {
      let param = '{"query":{"bool":{"must":{"bool": {"should":['
      for (var index in authorizationKeys) {
        param = param + '{"match":{"_index":"' + authorizationKeys[index].toLowerCase() + '"}},'
      }
      param = param.substring(0, param.length - 1) + ']}},"filter":{"range":{"timestamp":{"from":"' + date.dateF.toISOString() + '","to":"' + date.dateT.toISOString() + '"}}}}},'
      param = param + '"aggs":{"MB_server":{"sum":{"field":"MB_server"}},"MB_peer":{"sum":{"field":"MB_peer"}},"nbVues":{"cardinality":{"field":"new_client_uuid.keyword"}},"sec_server":{"sum":{"field":"sec_server"}},"sec_peer":{"sum":{"field":"sec_peer"}},"sec_rebuf":{"sum":{"field":"sec_rebuf"}}}}'
      let data = JSON.parse(param)
      var instance = {
        baseURL: base + '/_search?pretty',
        method: 'post',
        data: data,
      };
      axios(instance).then((response) => {
        done(response);

      }).catch((error) => {
        reject(error);
      })

    })
  }

  getAllGlobalAnalytics(date, index) {
    return new Promise((done, reject) => {
      /*
          if (period=="Last Day"){
              var date= new Date()
              var date2=new Date()
              date2.setDate(date.getDate()-1)
          }
          else if (period=="Last Hour"){
            var date= new Date()
            var date2=new Date()
            date2.setHours(date.getHours()-1)
            
          }
          else if (period=="Last 12 Hours"){
            var date= new Date()
            var date2=new Date()
            date2.setHours(date.getHours()-12)
            
          }
          else if (period=="Last Week"){
              var date= new Date()
              var date2=new Date()
              date2.setDate(date.getDate()-7)
          }
          else if (period=="Last Month"){
              var date= new Date()
              var date2=new Date()
              date2.setMonth(date.getMonth()-1)
          }
          else if (period=="This 12 Hours"){
            var date= new Date()
            var date2=new Date(date.getFullYear(),date.getMonth(),date.getDate(),date.getHours()-12,0,1)
          }
          else if (period=="This Hour"){
            var date= new Date()
            var date2= new Date(date.getFullYear(),date.getMonth(),date.getDate(),date.getHours(),0,1)
        }
          else if(period=="This Month"){
              var date= new Date()
              var date2= new Date(date.getFullYear(),date.getMonth(),1,0,0,1)
          }
          else if(period=="This Week"){
              var date= new Date()
              var date2= new Date(date.getFullYear(),date.getMonth(),date.getDate()-date.getDay()+1,0,0,1)
          }
          else if(period=="This Day"){
              var date= new Date()
              var date2= new Date(date.getFullYear(),date.getMonth(),date.getDate(),0,0,1)
          }
      */
      const params = {
        "query": {
          "bool": {
            "filter": {
              "range": {
                "timestamp": {
                  "from": date.dateF.toISOString(),
                  "to": date.dateT.toISOString()
                }
              }
            }
          }
        },
        "aggs": {
          "tot_nbVues": {
            "sum": {
              "field": "nbVues"
            }
          },
          "tot_data_delivered": {
            "sum": {
              "field": "tot_amount_data"
            }
          },
          "tot_hours_view": {
            "sum": {
              "field": "tot_hours_view"
            }
          },
          "tot_sec_peer": {
            "sum": {
              "field": "global_sec_peer"
            }
          },
          "tot_sec_server": {
            "sum": {
              "field": "global_sec_server"
            }
          },
          "tot_sec_rebuf": {
            "sum": {
              "field": "global_sec_rebuf"
            }
          },
          "tot_mb_peer": {
            "sum": {
              "field": "global_MB_peer"
            }
          },
          "tot_mb_server": {
            "sum": {
              "field": "global_MB_server"
            }
          }
        }
      };
      var instance = {
        baseURL: base + `/global${index.toLowerCase()}/_search?pretty`,
        method: 'post',
        data: params,
      };
      axios(instance).then((response) => {
        done(response);

      }).catch((error) => {
        reject(error);
      })

    })
  }

  getAnalytics(token, video, date) {
    return new Promise((done, reject) => {
      const params = {
        "query": {
          "bool": {
            "filter": {
              "range": {
                "timestamp": {
                  "from": date.dateF.toISOString(),
                  "to": date.dateT.toISOString()
                }
              }
            }
          }
        },
        "aggs": {
          "sum_sec_server": {
            "sum": {
              "field": "sec_server"
            }
          },
          "sum_sec_peer": {
            "sum": {
              "field": "sec_peer"
            }
          },
          "sum_sec_rebuff": {
            "sum": {
              "field": "sec_rebuf"
            }
          },
          "Tot_Mb_Peer": {
            "sum": {
              "field": "MB_peer"
            }
          },
          "Tot_Mb_Server": {
            "sum": {
              "field": "MB_server"
            }
          },
          "nbVues": {
            "cardinality": {
              "field": "new_client_uuid.keyword"
            }
          }
        }
      };
      var instance = {
        baseURL: base + '/' + video.toLowerCase() + '/_search?pretty',
        method: 'post',
        data: params,
      };
      axios(instance).then((response) => {
        done(response);

      }).catch((error) => {
        reject(error);
      })

    })
  }

  checkDataSourceExist(name, token) {
    axios({
      method: 'get',
      url: baseurl + '/api/analytics/' + name.toLowerCase(),
      headers: {
        Authorization: "Basic " + token
      }
    }).then(function (response) {
      if (response.status == 200) {
      }
    }).catch(error => {
    })

  }


  getBestCameras(param, user, token, pagesize, page, interval, filter) {
    pagesize = pagesize || 10;
    return new Promise((done, reject) => {
      var instance = {}
      if (param == "Viewing hours") {
        instance = {
          baseURL: baseurl + '/api/authorizationkeys',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ client: user, ...filter }),
            sort: JSON.stringify({ [`hourview_${interval}`]: -1 }),
            pagesize: pagesize,
            page: page,
            count: true
          }

        };
      }
      if (param == "Data delivered") {
        instance = {
          baseURL: baseurl + '/api/authorizationkeys',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ client: user, ...filter }),
            sort: JSON.stringify({ [`dataDelivered_${interval}`]: -1 }),
            pagesize: pagesize,
            page: page,
            count: true
          }

        };
      }
      if (param == "Views") {
        instance = {
          baseURL: baseurl + '/api/authorizationkeys',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ client: user, ...filter }),
            sort: JSON.stringify({ [`nbView_${interval}`]: -1 }),
            pagesize: pagesize,
            page: page,
            count: true
          }
        };
      }
      if (param == "Average viewing time") {
        instance = {
          baseURL: baseurl + '/api/authorizationkeys',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ client: user, ...filter }),
            sort: JSON.stringify({ [`meanTime_${interval}`]: -1 }),
            pagesize: pagesize,
            page: page,
            count: true
          }
        };
      }
      if (param == "Rebuff %") {
        instance = {
          baseURL: baseurl + '/api/authorizationkeys',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ client: user, ...filter }),
            sort: JSON.stringify({ [`rebuff_${interval}`]: 1 }),
            pagesize: pagesize,
            page: page,
            count: true
          }
        };
      }
      if (param == "Offload %") {
        instance = {
          baseURL: baseurl + '/api/authorizationkeys',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ client: user, ...filter }),
            sort: JSON.stringify({ [`offload_${interval}`]: -1 }),
            pagesize: pagesize,
            page: page,
            count: true
          }
        };
      }
      if (param == "Average bitrate") {
        instance = {
          baseURL: baseurl + '/api/authorizationkeys',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ client: user, ...filter }),
            sort: JSON.stringify({ [`bitrate_${interval}`]: -1 }),
            pagesize: pagesize,
            page: page,
            count: true
          }
        };
      }
      axios(instance).then((response) => {
        done(response);

      }).catch((error) => {
        reject(error);
      })
    })
  }

  getWorstCameras(param, user, token, pagesize) {
    pagesize = pagesize || 10;
    return new Promise((done, reject) => {
      if (param == "Viewing hours") {
        var instance = {
          baseURL: baseurl + '/api/authorizationkeys/my',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ user: user }),
            sort: JSON.stringify({ hourview: 1 }),
            pagesize: pagesize
          }

        };
      }
      if (param == "Data delivered") {
        var instance = {
          baseURL: baseurl + '/api/authorizationkeys/my',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ user: user }),
            sort: JSON.stringify({ dataDelivered: 1 }),
            pagesize: pagesize
          }

        };
      }
      if (param == "Views") {
        var instance = {
          baseURL: baseurl + '/api/authorizationkeys/my',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ user: user }),
            sort: JSON.stringify({ nbView: 1 }),
            pagesize: pagesize
          }
        };
      }
      if (param == "Average viewing time") {
        var instance = {
          baseURL: baseurl + '/api/authorizationkeys/my',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ user: user }),
            sort: JSON.stringify({ meanTime: 1 }),
            pagesize: pagesize
          }
        };
      }
      if (param == "Rebuff %") {
        var instance = {
          baseURL: baseurl + '/api/authorizationkeys/my',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ user: user }),
            sort: JSON.stringify({ rebuff: -1 }),
            pagesize: pagesize
          }
        };
      }
      if (param == "Offload %") {
        var instance = {
          baseURL: baseurl + '/api/authorizationkeys/my',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ user: user }),
            sort: JSON.stringify({ offload: 1 }),
            pagesize: pagesize
          }
        };
      }
      if (param == "Average bitrate") {
        var instance = {
          baseURL: baseurl + '/api/authorizationkeys/my',
          method: 'get',
          headers: {
            'Authorization': 'Basic ' + token
          },
          params: {
            filter: JSON.stringify({ user: user }),
            sort: JSON.stringify({ bitrate: 1 }),
            pagesize: pagesize
          }
        };
      }
      axios(instance).then((response) => {
        done(response);

      }).catch((error) => {
        reject(error);
      })
    })
  }

  getAnalyticsFromServer(key, query, token) {
    return new Promise((done, reject) => {
      var instance = {
        baseURL: baseurl + '/api/feedback',
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + token
        },
        data: {
          key: key + "*",
          query: query
        }
      };
      axios(instance).then((response) => {
        done(response.data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  getAnalyticsFromCDN(dates, client, token) {
    return new Promise((done, reject) => {
      var instance = {
        baseURL: baseurl + '/api/feedback/cdn',
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + token
        },
        data: {
          dates: dates,
          client: client
        }
      };
      axios(instance).then((response) => {
        done(response.data);
      }).catch((error) => {
        reject(error);
      })
    });
  }

  getRunningVideos(client, token) {
    return new Promise((done, reject) => {
      var instance = {
        baseURL: baseurl + '/api/feedback/running',
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + token
        },
        data: {
          key: client
        }
      };
      axios(instance).then((response) => {
        done(response.data);
      }).catch((error) => {
        reject(error);
      })
    });
  }


}